<template lang="pug">
  img(
    :src="src"
    :srcset="srcset"
  )
</template>

<script>
export default {
  props: {
    name: { type: String, required: true },
  },
  computed: {
    src() {
      return this.assetPath(`retina-images/${this.name}.jpg`)
    },
    srcset() {
      return this.assetSrcSet(`retina-images/${this.name}.jpg`)
    },
  },
}
</script>
